<template src="./field-area.html"></template>
<style lang="less" src="./field-area.less"></style>

<script>
	export default {
		
	}
</script>